import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';

function getHTML(html: string) {
    return {
        __html: html,
    };
}

type HelpTextModalProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    content: string;
};

export default function HelpTextModal({
    isOpen,
    setIsOpen,
    content,
}: HelpTextModalProps) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} className={"modal"} overlayClassName={"modal-container"}>
            <div className="modal__header">
                <h2 className={"form-option__title"}>{t('Why do we ask this?')}</h2>
                <button className={"modal__close-button"} type="button" onClick={() => setIsOpen(false)}>
                    {t('X')}
                </button>
            </div>
            <div dangerouslySetInnerHTML={getHTML(content)} />
        </Modal>
    );
}
